import { SectionComponent } from './SectionComponent';
import { IPageSectionEntry } from '../../../contentful';

interface IProps {
	sections?: IPageSectionEntry[];
}
export function PageSections({ sections }: IProps) {
	if (!Array.isArray(sections)) {
		return null;
	}

	return (
		<>
			{sections.map((section: IPageSectionEntry) => (
				// <div  id={`section-${section.id}`}>
				<SectionComponent
					key={section.id}
					section={section}
					id={`section-${section.id}`}
				/>
				// </div>
			))}
		</>
	);
}
